<template>
  <div v-if="listingBar">
  <section class="uk-section uk-padding-remove-vertical uk-margin-remove coupon-list">
    <div class="uk-container uk-container-xsmall perks-rewards-wrap uk-text-center">
      <div class="uk-child-width-1-3" uk-grid>
        <div v-on:click="clickList">
          <span uk-icon="icon: list;"></span> {{ $t("List") }}
        </div>
        <div v-on:click="clickType">
          <span uk-icon="icon: info;"></span> {{ $t("Type") }}
        </div>
        <div v-on:click="clickMap">
          <span uk-icon="icon: location;"></span> {{ $t("Map") }}
        </div>
      </div>
    </div>
  </section>
  </div>
</template>
<script>
import coreMixin from '../mixins/coreMixin'
const listingBarDefault = false

export default {
  mixins: [coreMixin],
  computed: {
    listingBar () {
      if (this.$route.meta.listingbar !== '') {
        return this.$route.meta.listingbar
      } else {
        return listingBarDefault
      }
    }
  },
  methods: {
    clickList: function () {
      let _rootSection = this.$route.meta.rootSection
      this.$router.push('/' + _rootSection)
    },
    clickType: function () {
      let _rootSection = this.$route.meta.rootSection
      this.$router.push('/' + _rootSection + '/type')
    },
    clickMap: function () {
      let _rootSection = this.$route.meta.rootSection
      this.$router.push('/' + _rootSection + '/map')
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/ListingNavBar.vue